import React,{useState,useEffect} from 'react';
import { message } from 'antd';
import {Tools} from '../../../utils'
import {LoginApi} from '../../../api'
import { UserAgreement, ConsultAgreement } from '../../../utils/Config'
import { SmsCode } from '../../../components'

function WechatFirstLogin(props)  {

  const [tel, onTelChange] = useState('');
  const [verCode, onVerCodeChange] = useState('');
  const [agreeable, setAgreeable] = useState(false);

  //校验手机号
  const onTelTextChange = (val) => {
    onTelChange(val);
  };
  

  const onLoginClick = async() => {
    if(!Tools.verifyTel(tel)) {
      return message.error('请输入正确手机号码')
    }
    if(!verCode){
      return message.error('请输入验证码')
    }
    if(!agreeable) {
      return message.error('请阅读并勾选下方协议')
    }
    try {
      const res = await LoginApi.accountLogin(tel,verCode,props.wechatData)
      if(res && res.success) {
        localStorage.setItem("access_token", res.data.access_token)
        localStorage.setItem("userInfo", JSON.stringify(res.data.user))
        localStorage.setItem("isReal", res.data.user.identity_authentication)
        props.onCloseModal()
        props.linkClick()
      }
    }catch(e) {
      console.log(e, "err")
    }
  }

  const onAgreeClick = () => {
    setAgreeable(!agreeable)
  }
  const onProtocol = () => {
    window.open(UserAgreement);
  }
  const onPrivacy = () => {
    window.open(ConsultAgreement);
  }

  return (
      <div>
          <div>
            <div className='logo-wrap'>
              <div className='title-wrap'>
                <span className='modal-title'>请绑定手机号码</span>
              </div>
            </div>
            <div className='input-wrap'>
              <input 
                className='num-input' 
                placeholder='请输入手机号'
                max={11}
                type='number'
                value={tel}
                onChange={(e) => onTelTextChange(e.target.value)}
              />
            </div>
            <div className='input-wrap-bottom'>
              <input 
                className='code-input' 
                placeholder='请输入短信验证码'
                type='text'
                value={verCode}
                maxLength={6}
                onChange={(e) => {
                  onVerCodeChange(e.target.value)
                }}
              />
              <div className='line-icon' />
              <SmsCode phone={tel}/>
            </div>
            <div className='agree-wrap'>
              <div className={["agree-icon", agreeable ? "agree-enabled" : null].join(' ')} onClick={onAgreeClick}></div>
              <div className='agree-text'>已阅读并同意</div>
              <div className="agree-link" onClick={onProtocol}>
                《用户协议》
              </div>
              <div className="agree-link">、</div>
              <div className="agree-link" onClick={onPrivacy}>
                《隐私协议》
              </div>
            </div>
            <button 
              className='submit-button'
              onClick={() => onLoginClick()}>
              绑定
            </button>
          </div>
      </div>
  )
}

export default WechatFirstLogin